import React, { AriaRole } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconBackOutline } from '@saucelabs/ds-icons';

import { pressMobileDeviceHardwareButton } from '../../../actions';
import { MOBILE_DEVICE_HARDWARE_BUTTON_TYPES } from '../../../constants';
import GenericButton from './GenericButton';
import selectors from '../selectors';

const BackButton: React.FC<{ role?: AriaRole }> = ({ role }) => {
  const dispatch = useDispatch<ReduxDispatcher>();
  const { deviceToolsDisabled } = useSelector(selectors.toolbarButtonSelector);

  return (
    <GenericButton
      disabled={deviceToolsDisabled}
      icon={IconBackOutline}
      label="Back (Device)"
      onPress={() => {
        void dispatch(
          pressMobileDeviceHardwareButton(MOBILE_DEVICE_HARDWARE_BUTTON_TYPES.BACK),
        );
      }}
      role={role}
    />
  );
};

BackButton.displayName = 'BackButton';

export default BackButton;
